import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TypedMemo } from '../../../common/types';
import { SMLRouteNames } from '../../../../routing/sml/SMLRoutes';
import { buildQuery } from '../../../../routing/utils/buildQuery';
import { readCheckoutIntent } from '../../config/checkoutIntent';

export interface SMLPricingProps {
  /** The redux "show the plans" flag (`toggleSMLPricingModal`). */
  isOpen: boolean;
  /** Clears the flag and the checkout intent. */
  toggle: () => void;
}

/**
 * The plans are a page now (`/app/plans`, design plans-page a), not a modal. Every caller still
 * sets the old redux flag (`useOpenPlans`, the upgrade prompt, a checkout intent). This host turns
 * the flag into a navigation: the plan of a checkout intent and the page that asked go in the
 * query, then the flag and the intent are cleared. It draws nothing.
 */
const SMLPricingComponent: React.FC<SMLPricingProps> = ({ isOpen, toggle }) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const onPlansPage = pathname.replace(/^\//, '').split('/')[0] === SMLRouteNames.plans;
    if (!onPlansPage) {
      const intent = readCheckoutIntent();
      const query = buildQuery({
        ...(intent === null ? {} : { plan: intent.plan, interval: intent.interval }),
        from: `${pathname}${search}`,
      });
      // eslint-disable-next-line no-void
      void navigate(`/${SMLRouteNames.plans}${query}`);
    }
    toggle();
  }, [isOpen, navigate, pathname, search, toggle]);

  return null;
};

export const SMLPricing = TypedMemo(SMLPricingComponent);
